import React, { FC } from 'react'
import { Oberoy } from '../templates'
import HomeCarousel from '../components/home-carousel/HomeCarousel'
import Recognition from '../components/recognition/Recognition'
import GoogleMapEmbed from '../components/googleMapEmbed/GoogleMapEmbed'
import FacilitiesPreview from '../components/facilities-preview/FacilitiesPreview'
import GalleryPreview from '../components/gallery-preview/GalleryPreview'

export const Root: FC = () => (
  <React.Fragment>
    <HomeCarousel />
    <FacilitiesPreview />
    <GalleryPreview />
    <Recognition />
    <GoogleMapEmbed />
  </React.Fragment>
)

const RootPage: FC = () => (
  <Oberoy>
    <Root />
  </Oberoy>
)

export default RootPage
